import { render } from "./HeroiconsOutlineCheckCircle.vue?vue&type=template&id=5cb4843a"
const script = {}

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCheckCircle.vue"]])

export default __exports__